<ng-template #noGroupsTmpl let-items [ngTemplateType]="ListTemplateContext">
  @for (
    option of items;
    track trackByOption(itemIndex, option);
    let itemIndex = $index;
    let last = $last
  ) {
    <div
      #filteredOptions
      [class.disabled]="option.disabled"
      [hidden]="hideSelectedOption && selectedOption?.value === option.value"
      (click)="
        !option.disabled && !option.nestedOptions?.length && selectOption(option);
        $event.preventDefault();
        $event.stopPropagation()
      "
      class="item"
    >
      <rt-dropdown-item
        class="text"
        [e2eSelector]="e2eSelector ? e2eSelector + ':item:' + option.value : null"
        [class.padding-left]="itemTextLeftPadding"
        [noDivider]="last || (last && !!footerTemplate)"
        [highlighted]="selectedOptionIndex === itemIndex"
        [targetFor]="(option.nestedOptions?.length && nestedOptionsTpl) || undefined"
        [dropdownComponentRef]="dropdownComponentRef"
        [hasChevronRight]="!!option.nestedOptions?.length"
      >
        <ng-template
          [ngTemplateOutlet]="optionTemplate || optionDefaultTemplate"
          [ngTemplateOutletContext]="{ option: option, selectedOption: selectedOption }"
        >
        </ng-template>
      </rt-dropdown-item>
    </div>
    <ng-template #nestedOptionsTpl>
      <ng-container
        [ngTemplateOutlet]="backHeaderTemplate"
        [ngTemplateOutletContext]="{ label: option.label }"
      ></ng-container>
      <ng-container
        [ngTemplateOutlet]="noGroupsTmpl"
        [ngTemplateOutletContext]="{ $implicit: option.nestedOptions }"
      ></ng-container>
    </ng-template>
  }
</ng-template>

<ng-template #groupsTmpl let-items [ngTemplateType]="GroupsTemplateContext">
  @for (
    group of items;
    track trackByGroup($index, group);
    let first = $first;
    let lastGroup = $last
  ) {
    <div>
      <ng-template
        [ngTemplateOutlet]="groupHeaderTemplate || groupHeaderDefaultTemplate"
        [ngTemplateOutletContext]="{ group: group, first: first }"
      >
      </ng-template>

      @for (option of group.options; track trackByOption($index, option); let last = $last) {
        <rt-dropdown-item
          #filteredOptions
          [class.disabled]="option.disabled"
          [highlighted]="option.uuid === selectedItemUuid"
          [noDivider]="last && lastGroup"
          [targetFor]="(option.nestedOptions?.length && nestedOptionsTpl) || undefined"
          [dropdownComponentRef]="dropdownComponentRef"
          [hasChevronRight]="!!option.nestedOptions?.length"
          (click)="
            !option.disabled && !option.nestedOptions?.length && selectOption(option);
            $event.preventDefault();
            $event.stopPropagation()
          "
          class="item group"
        >
          <div>
            <ng-template
              [ngTemplateOutlet]="optionTemplate || optionDefaultTemplate"
              [ngTemplateOutletContext]="{ option: option }"
            >
            </ng-template>
          </div>
        </rt-dropdown-item>
        <ng-template #nestedOptionsTpl>
          <ng-container
            [ngTemplateOutlet]="backHeaderTemplate"
            [ngTemplateOutletContext]="{ label: option.label }"
          ></ng-container>

          <ng-container
            [ngTemplateOutlet]="groupsTmpl"
            [ngTemplateOutletContext]="{ $implicit: option.nestedOptions }"
          ></ng-container>
        </ng-template>
      }
    </div>
  }
</ng-template>

<ng-template #defaultScrollTmpl let-items [ngTemplateType]="GroupsOrListTemplateContext">
  <ng-container
    [ngTemplateOutlet]="hasGroups ? groupsTmpl : noGroupsTmpl"
    [ngTemplateOutletContext]="{ $implicit: items }"
  ></ng-container>
</ng-template>

<ng-template #virtualScrollTmpl let-items [ngTemplateType]="GroupsOrListTemplateContext">
  <virtual-scroller
    #virtualScroll
    [bufferAmount]="5"
    [scrollAnimationTime]="0"
    [scrollThrottlingTime]="10"
    [enableUnequalChildrenSizes]="true"
    [executeRefreshOutsideAngularZone]="true"
    [items]="items"
    (vsUpdate)="onVirtualScrollUpdate($event)"
    [style.height.px]="hasSearch ? 210 : 270"
  >
    <ng-container
      [ngTemplateOutlet]="defaultScrollTmpl"
      [ngTemplateOutletContext]="{ $implicit: virtualScroll.viewPortItems }"
    ></ng-container>
  </virtual-scroller>
</ng-template>

@if (label) {
  <rt-label margin-bottom-small-xx>
    {{ label }}
  </rt-label>
}

<div (keydown)="handleKeyDown($event)">
  <div #dropdownContainer #selectDropdownTrigger="rtOverlayOrigin" rt-overlay-origin>
    @if (multiple && selectedOptions.length > 0) {
      <div class="selected-labels">
        @for (option of selectedOptions; track trackByOption($index, option)) {
          <div class="selected-label">
            <ng-template
              [ngTemplateOutlet]="labelTemplate || labelDefaultTemplate"
              [ngTemplateOutletContext]="{
                option: option,
                removeValue: removeValue,
                wrapLabelText: wrapLabelText
              }"
            >
            </ng-template>
          </div>
        }
      </div>
    }

    <ng-template
      [ngTemplateOutlet]="triggerTemplate || triggerDefaultTemplate"
      [ngTemplateOutletContext]="{
        disabled: disabled,
        readOnly: readOnly,
        placeholder: placeholder,
        selectedOption: selectedOption,
        dropdownOpened: dropdownOpened,
        toggleDropdown: toggleDropdown,
        $implicit: triggerTemplateContext
      }"
    >
    </ng-template>
  </div>

  <ng-template
    #selectDropdownOverlay="rtConnectedOverlay"
    [origin]="selectDropdownTrigger"
    [positions]="dropdownPositions!"
    (backdropClick)="toggleDropdown(false)"
    rt-connected-overlay
    [hasBackdrop]="true"
  >
    <rt-select-dropdown
      [scrollTop]="scrollTop"
      [width]="minDropdownWidth || maxDropdownWidth ? null : dropdownWidth"
      [minWidth]="minDropdownWidth"
      [maxWidth]="maxDropdownWidth"
      [noMaxHeight]="noMaxHeight!"
      [footerTemplate]="footerTemplate"
      [footerTemplateContext]="footerTemplateContext"
      [hasStickyFooter]="hasStickyFooter!"
    >
      <ng-template [ngTemplateOutlet]="headerTemplate || null"></ng-template>
      @if (hasSearch) {
        <div padding-tb-small-x padding-lr-small-x>
          <rt-form-field (click)="$event.preventDefault()" class="context-default">
            <rt-input
              #searchQueryInput
              [value]="searchQuery"
              [autoFocus]="true"
              [hasClearButton]="true"
              (valueChange)="changeSearchQuery($event)"
              (keydown)="handleSearchInputKeydown($event)"
              variant="rounded"
              [placeholder]="searchPlaceholder || ('rtu.common.search' | translate)"
            >
              <rt-icon prefix name="search"></rt-icon>
            </rt-input>
          </rt-form-field>
        </div>
      }
      <div [style.max-height.px]="hasSearch ? 210 : 270" class="scroll-container">
        <ng-container
          [ngTemplateOutlet]="
            virtualScrollEnabled && virtualScrollThresholdExceeded
              ? virtualScrollTmpl
              : defaultScrollTmpl
          "
          [ngTemplateOutletContext]="{
            $implicit: hasGroups ? filteredGroupsOptions : filteredOptions
          }"
        ></ng-container>
      </div>

      @if (!filteredOptions.length && !filteredGroupsOptions.length) {
        <rt-dropdown-item>
          {{ noResultsMessage }}
        </rt-dropdown-item>
      }

      @if (!hasStickyFooter) {
        <ng-template [ngTemplateOutlet]="footerTemplate || footerDefaultTemplate"> </ng-template>
      }
    </rt-select-dropdown>
  </ng-template>
</div>

<ng-template
  #triggerDefaultTemplate
  let-disabled="disabled"
  let-readOnly="readOnly"
  let-placeholder="placeholder"
  let-selectedOption="selectedOption"
  let-dropdownOpened="dropdownOpened"
  let-toggleDropdown="toggleDropdown"
  [ngTemplateType]="TriggerTemplateContext"
>
  @if (!hasInputTrigger) {
    <rt-button
      #trigger
      [disabled]="disabled || readOnly"
      [attr.tabindex]="disabled ? null : tabIndex || null"
      (click)="!disabled && !readOnly && toggleDropdown(true)"
      [e2eSelector]="e2eSelector ? e2eSelector + ':trigger' : null"
      variant="tertiary"
      [dropdownOpened]="dropdownOpened"
    >
      <div layout layout-full-width layout-space-between>
        <!-- SECURITY: Right now we allow any html in here... but maybe we'll change it in the future? -->
        @if (!(selectedOption && selectedOption.value && selectedOption.label)) {
          <span
            [innerHTML]="placeholder"
            [class.placeholder-bold]="boldPlaceholder"
            class="select-placeholder"
          >
          </span>
        }
        @if (selectedOption && selectedOption.value && selectedOptionLabel) {
          <span [class.hide-text-overflow]="hideTextOverflow">
            @if (selectedOptionIconLeft) {
              <div layout-horizontal layout-align-items-center>
                <rt-icon [name]="selectedOptionIconLeft" margin-right-small-x></rt-icon>
                <rt-truncate>{{ selectedOptionLabel }}</rt-truncate>
              </div>
            }
            @if (!selectedOptionIconLeft) {
              <rt-truncate>{{ selectedOptionLabel }}</rt-truncate>
            }
          </span>
        }
      </div>
    </rt-button>
  }

  @if (hasInputTrigger) {
    <rt-input
      #trigger
      [disabled]="disabled"
      [readOnly]="true"
      [placeholder]="placeholder"
      [tabIndex]="tabIndex"
      [hasDropdownIndicator]="!readOnly"
      [class.dropdownOpened]="dropdownOpened"
      [value]="
        labelOverride
          ? labelOverride
          : multiple
            ? ''
            : selectedOption?.value && selectedOption?.label
              ? selectedOptionLabel
              : ''
      "
      [invalid]="isInvalid"
      [e2eSelector]="e2eSelector ? e2eSelector + ':trigger' : null"
      (click)="!disabled && !readOnly && !dropdownOpened && toggleDropdown(true)"
      variant="rounded"
    >
    </rt-input>
  }
</ng-template>

<ng-template
  #optionDefaultTemplate
  let-option="option"
  [ngTemplateType]="SelectOptionContext"
  ngPreserveWhitespaces
>
  <span
    [attr.padding-left-small-x]="hasItemPadding ? '' : null"
    [class.word-break]="optionWordBreak"
  >
    @if (option.icon) {
      <rt-icon [name]="option.icon" class="option-icon"></rt-icon>
    }
    @if (includeEmptyOption && iconEmptyLabel && option.value === '') {
      <span class="empty-label-icon">
        <rt-icon name="remove"></rt-icon>
      </span>
    } @else {
      {{ option.label }}
    }
  </span>
  @if (option.count !== undefined && option.count !== null) {
    <span text-default>({{ option.count }}) </span>
  }
  @if (option.badgeText) {
    <rt-badge color="secondary" [text]="option.badgeText" margin-left-small-xx></rt-badge>
  }
</ng-template>

<ng-template
  #labelDefaultTemplate
  let-option="option"
  let-removeValue="removeValue"
  let-wrapLabelText="wrapLabelText"
  [ngTemplateType]="LabelTemplateContext"
>
  <rt-tag
    [name]="option.label"
    [wrapText]="wrapLabelText"
    [deletable]="true"
    [counter]="option.count"
    [isClickable]="false"
    [isHoverable]="false"
    (deleteClick)="removeValue(option.value!)"
  >
  </rt-tag>
</ng-template>
<ng-template
  #groupHeaderDefaultTemplate
  let-group="group"
  let-first="first"
  [ngTemplateType]="GroupHeaderTemplateContext"
>
  @if (group.title) {
    <rt-dropdown-header [isSubheading]="true">
      {{ group.title }}
    </rt-dropdown-header>
  }
</ng-template>

<ng-template #footerDefaultTemplate></ng-template>
<ng-template #backHeaderTemplate let-label="label">
  <rt-dropdown-header>
    <rt-icon-button
      prefix
      variant="plain"
      iconName="arrow-back"
      shape="square"
      size="small"
      (click)="dropdownComponentRef.prevTemplate(); $event.preventDefault()"
    ></rt-icon-button>
    {{ label }}
  </rt-dropdown-header>
</ng-template>
